/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, {
  useState, useRef, useEffect, createRef,
} from 'react';
import { connect } from 'react-redux';
import {
  Collapse,
  Row,
  Col,
  Card,
} from 'antd';
import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import {
  MESSAGES,
} from 'appconstants';
import {
  SpButton,
  SpText,
  SpError,
} from 'components/DesignKit';
import { CaretRightOutlined } from '@ant-design/icons';
import SimpleReactValidator from 'simple-react-validator';
import {
  acquirerActions,
  notificationActions,
  inventoryShopsActions,
} from 'store/actions';
import {
  ACQUIRER,
  NOTIFICATION,
} from 'store/actionTypes';

import BussinessType from './components/BussinessType';
import Branding from './components/Branding';
import Customize from './components/Customize';
import PaymentNote from './components/PaymentNote';
import Customer from './components/Customer';
import PaymentOrder from './components/PaymentOrder';
import Print from './components/Print';
import ServiceType from './components/ServiceType';

const { Panel } = Collapse;

type Props = {
  setNotification: Function,
  fetchInventoryShops: Function,
  shopsList: Array,
};

const KiosSettings = (props: Props) => {
  const {
    setNotification,
    fetchInventoryShops,
    shopsList,
  } = props;

  const [, forceUpdate] = useState();
  const businessRef = createRef();
  const brandingRef = createRef();
  const customizeRef = createRef();
  const paymentRef = createRef();
  const serviceRef = createRef();
  const paymentSuccessRef = createRef();
  const customerRef = createRef();
  const printRef = createRef();

  const [refArray, setRefArray] = useState([
    businessRef,
    brandingRef,
    customizeRef,
    paymentRef,
    serviceRef,
    paymentSuccessRef,
    customerRef,
    printRef,
  ]);

  const [businessInfo, setBusinessInfo] = useState({});
  const [brandingInfo, setBrandingInfo] = useState({});
  const [customizeInfo, setCustomizeInfo] = useState({});
  const [paymentInfo, setPaymentInfo] = useState({});
  const [serviceInfo, setServiceInfo] = useState({});
  const [paymentSuccessInfo, setPaymentSuccessInfo] = useState({});
  const [customerInfo, setCustomerInfo] = useState({});
  const [printInfo, setPrintInfo] = useState({});
  const [isError, setIsError] = useState(false);
  const [kioskGid, setKioskGid] = useState('');
  const [bussinessType, setBussinessType] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [brandingCustom, setBrandingCustom] = useState('');

  const getData = async () => {
    try {
      const { data: { entity } } = await axiosAuthInstance.get(`${API_END_POINTS.KIOSK_SETTINGS}`);
      setKioskGid(entity?.content?.[0]?.gid);
      const business = {
        bussinessType: entity?.content?.[0]?.settingsMeta?.bussinessType || '',
      };
      setBussinessType({
        bussinessType: entity?.content?.[0]?.settingsMeta?.bussinessType || '',
      });
      const branding = {
        shopName: entity?.content?.[0]?.settingsMeta?.shopName || '',
        shopAddress: entity?.content?.[0]?.settingsMeta?.shopAddress || '',
        themeColor: entity?.content?.[0]?.settingsMeta?.themeColor || '',
        textColor: entity?.content?.[0]?.settingsMeta?.textColor || '',
        logo: entity?.content?.[0]?.settingsMeta?.logo || '',
      };
      const custom = {
        heroText: entity?.content?.[0]?.settingsMeta?.heroText || '',
        subText: entity?.content?.[0]?.settingsMeta?.subText || '',
        btnText: entity?.content?.[0]?.settingsMeta?.btnText || '',
        bgLogo: entity?.content?.[0]?.settingsMeta?.bgLogo || '',
      };
      const payment = {
        note: entity?.content?.[0]?.settingsMeta?.note || '',
      };
      const serv = {
        serviceType: entity?.content?.[0]?.settingsMeta?.serviceType || '',
        serviceTypes: entity?.content?.[0]?.settingsMeta?.serviceTypes || '',
      };
      const order = {
        content: entity?.content?.[0]?.settingsMeta?.content || '',
        addition: entity?.content?.[0]?.settingsMeta?.content || '',
        orderNumber: entity?.content?.[0]?.settingsMeta?.orderNumber || false,
      };
      const cust = {
        name: entity?.content?.[0]?.settingsMeta?.name || '',
        phone: entity?.content?.[0]?.settingsMeta?.phone || '',
        email: entity?.content?.[0]?.settingsMeta?.email || '',
        address: entity?.content?.[0]?.settingsMeta?.address || '',
        star: entity?.content?.[0]?.settingsMeta?.star || '',
        raasi: entity?.content?.[0]?.settingsMeta?.raasi || '',
        gothram: entity?.content?.[0]?.settingsMeta?.gothram || '',
        nameRequired: entity?.content?.[0]?.settingsMeta?.nameRequired || '',
        phoneRequired: entity?.content?.[0]?.settingsMeta?.phoneRequired || '',
        emailRequired: entity?.content?.[0]?.settingsMeta?.emailRequired || '',
        addressRequired: entity?.content?.[0]?.settingsMeta?.addressRequired || '',
        starRequired: entity?.content?.[0]?.settingsMeta?.starRequired || '',
        raasiRequired: entity?.content?.[0]?.settingsMeta?.raasiRequired || '',
        gothramRequired: entity?.content?.[0]?.settingsMeta?.gothramRequired || '',
      };
      const print = {
        withLogo: entity?.content?.[0]?.printerSettingsMeta?.withLogo || false,
        printLogo: entity?.content?.[0]?.printerSettingsMeta?.printLogo || '',
      };
      setBusinessInfo(business);
      setBrandingInfo(branding);
      setBrandingCustom(branding);
      setCustomizeInfo(custom);
      setPaymentInfo(payment);
      setServiceInfo(serv);
      setPaymentSuccessInfo(order);
      setCustomerInfo(cust);
      setPrintInfo(print);
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  };

  useEffect(() => {
    const sortParams = '&sortBy=createdAt&direction=DESC';
    const currentPage = 1;
    const filterParams = '';
    fetchInventoryShops({ currentPage, sortParams, filterParams });
    getData();
  }, []);

  const brandingUpdate = (data) => {
    setBrandingCustom(data);
  };

  useEffect(() => {

  }, [brandingCustom]);

  const bussinessChange = (info) => {
    setBussinessType({
      bussinessType: info || '',
    });
  };

  useEffect(() => {
    setRefArray(existingElements => (
      [...existingElements]
    ));
  }, []);

  const [activePanel, setActivePanel] = useState();

  const simpleValidator = useRef(new SimpleReactValidator());

  simpleValidator.current.purgeFields();

  function callback(key) {
    setActivePanel(key[0]);
    setIsError(false);
    setErrorMsg('');
    if (key.length > 1) {
      const newKey = new Array(key.at(-1));
      setActivePanel(newKey);
    } else setActivePanel(key[0]);
  }

  const handleSubmit = async () => {
    const settingsMeta = {
      ...businessInfo, ...brandingInfo, ...customizeInfo, ...paymentInfo, ...serviceInfo, ...paymentSuccessInfo, ...customerInfo, ...printInfo, ...isError,
    };
    const printerSettingsMeta = {
      withLogo: printInfo?.withLogo || false,
      printLogo: printInfo?.withLogo ? printInfo?.printLogo : '',
    };
    const payload = {
      settingsMeta,
      printerSettingsMeta,
    };
    if (!brandingInfo?.logo) {
      setIsError(true);
      setErrorMsg('Logo image is required');
      return;
    }
    console.log(printInfo?.withLogo, printInfo?.printLogo);
    if ((printInfo?.withLogo === true) && printInfo?.printLogo === '') {
      setIsError(true);
      setErrorMsg('Print logo is required');
      return;
    }
    if (!customizeInfo?.bgLogo) {
      setIsError(true);
      setErrorMsg('Background image is required');
      return;
    }
    try {
      if (kioskGid) {
        const { data: { entity } } = await axiosAuthInstance.patch(`${API_END_POINTS.KIOSK_SETTINGS}/${kioskGid}`, payload);
        console.log(entity, 'patch');
      } else {
        const { data: { entity } } = await axiosAuthInstance.post(`${API_END_POINTS.KIOSK_SETTINGS}`, payload);
        console.log(entity, 'entityentityentityentity');
      }
      getData();
      setIsError(false);
      setNotification({
        type: NOTIFICATION.SUCCESS,
        payload: 'KIOSK Settings updated successfully.',
      });
    } catch (e) {
      setNotification({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  };

  return (
    <Card>
      <Row type="flex" justify="space-between" className="my-2 mb-3">
        <Col>
          <SpText className="text-uppercase" fontSize="20px">
            KIosk  Tab Configurations
          </SpText>
        </Col>
      </Row>
      {
        isError ? (
          <Row type="flex" justify="space-between" className="my-2 mb-3">
            <Col>
              <SpError>
                {errorMsg}
              </SpError>
            </Col>
          </Row>
        ) : (
          <></>
        )
      }
      <div className="mr-4">
        <Collapse
          bordered={false}
          onChange={callback}
          activeKey={activePanel}
          expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          className="site-collapse-custom-collapse"
        >
          <Panel header="Business Type" key="1">
            <BussinessType
              ref={refArray[0]}
              businessInfo={businessInfo}
              bussinessChange={bussinessChange}
            />
          </Panel>
          <Panel header="Branding & Styling" key="2">
            <Branding
              ref={refArray[1]}
              brandingInfo={brandingInfo}
              brandingUpdate={brandingUpdate}
              businessInfo={bussinessType}
            />
          </Panel>
          <Panel header="Customize Welcome Screen" key="3">
            <Customize
              ref={refArray[2]}
              customizeInfo={customizeInfo}
              brandingInfo={brandingCustom}
            />
          </Panel>
          <Panel header="Payment Notes" key="4">
            <PaymentNote
              ref={refArray[3]}
              paymentInfo={paymentInfo}
            />
          </Panel>
          <Panel header="Service Type" key="5">
            <ServiceType
              ref={refArray[4]}
              serviceInfo={serviceInfo}
              shopData={shopsList}
            />
          </Panel>
          <Panel header="Payment successful screen" key="6">
            <PaymentOrder
              ref={refArray[5]}
              paymentSuccessInfo={paymentSuccessInfo}
            />
          </Panel>
          <Panel header="Customer Details" key="7">
            <Customer
              ref={refArray[6]}
              customerInfo={customerInfo}
              businessInfo={businessInfo}
            />
          </Panel>
          <Panel header="Print Receipt" key="8">
            <Print
              ref={refArray[7]}
              printInfo={printInfo}
            />
          </Panel>
        </Collapse>
        <hr />
        <Row type="flex" justify="end" gutter={[16, 16]}>
          <Col>
            <SpButton
              type="primary"
              shape="round"
              onClick={handleSubmit}
            >
              Save
            </SpButton>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

const mapStateToProps = state => ({
  internalAccount: state.account.internalAccount,
  acquirerResult: state.acquirer.acquirerSearch.content,
  loading: state.loading.loading,
  validator: state.loading.validator,
  test: state.account.test,
  shopsList: state.inventoryShops.content,
});

const mapDispatchToProps = dispatch => ({
  fetchAcquirerSearch: param => dispatch(acquirerActions.fetchAcquirerSearch({
    type: ACQUIRER.SEARCH_FETCH,
    payload: param,
  })),
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  fetchInventoryShops: param => dispatch(inventoryShopsActions.fetchInventoryShops({
    payload: param,
  })),
});

// $FlowFixMe
export default connect(mapStateToProps, mapDispatchToProps)(KiosSettings);
